import LicenseItem from './LicenseItem';

export default LicenseItem;
